/* eslint-disable jsx-a11y/label-has-associated-control */
import EditIcon from '@material-ui/icons/Edit';
import Skeleton from '@material-ui/lab/Skeleton';
import { UserInitials } from '@orientaction/commons';
import { useUpload } from '@orientaction/hooks';
import { ChangeEvent, useContext, useMemo } from 'react';
import { UserProfilePhotoContext } from '../../../../Context/UserProfilePhotoContext';
import RedesignImage from '../components/RedesignImage';
import { useProfileEditPhotoStyles } from './ProfileEditPhoto.styles';

type ProfileEditPhotoProps = {
  user: Record<string, any>;
  currentUser: Record<string, any>;
  setUser: (user: Record<string, any>) => void;
  loading: boolean;
};

const ProfileEditPhoto = ({ user, currentUser, setUser, loading }: ProfileEditPhotoProps) => {
  const classes = useProfileEditPhotoStyles();
  const { userProfilePhoto, updateUserProfilePhoto } = useContext<any>(UserProfilePhotoContext);
  const { uploadToStore } = useUpload({ user, setUser, updateUserProfilePhoto });

  const inputId = useMemo(
    () => `profile-edit-photo-input-${user?.id ?? 'default'}`,
    [user?.id]
  );

  const handleModify = (event: ChangeEvent<HTMLInputElement>) => {
    const acceptedFiles = event.target.files;
    if (acceptedFiles) {
      uploadToStore(acceptedFiles, `profiles/${user.id}`);
    }
  };

  const userPhotoUri = user?.id === currentUser?.id ? userProfilePhoto : user?.photoUri;

  if (loading) {
    return <Skeleton variant="circle" className={classes.profilePhotoImage} />;
  }

  const photoContent =
    userPhotoUri?.length > 0 ? (
      <RedesignImage
        priority={true}
        src={userPhotoUri}
        className={classes.profilePhotoImage}
        alt="profile"
      />
    ) : (
      <UserInitials
        lastname={user?.lastname ?? ''}
        firstname={user?.firstname ?? ''}
        overrideClassname={classes.profilePhotoImage}
      />
    );

  return (
    <>
      <input
        accept="image/*"
        className={classes.profilePhotoInput}
        id={inputId}
        multiple={false}
        type="file"
        onChange={handleModify}
      />
      <label htmlFor={inputId} className={classes.profilePhotoLabel} aria-label="Modifier la photo de profil">
        <div className={classes.profilePhotoWrapper}>
          {photoContent}
          <div className={classes.profilePhotoOverlay}>
            <EditIcon className={classes.profilePhotoOverlayIcon} />
          </div>
        </div>
      </label>
    </>
  );
};

export default ProfileEditPhoto;
